import { render, staticRenderFns } from "./ProductsWinEdit.vue?vue&type=template&id=9fa25988&scoped=true&"
import script from "./ProductsWinEdit.vue?vue&type=script&lang=js&"
export * from "./ProductsWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductsWinEdit.vue?vue&type=style&index=0&id=9fa25988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa25988",
  null
  
)

export default component.exports